4<template>
  <b-modal
    v-model="modal"
    :title="title"
    size="lg"
    :no-enforce-focus="true"
    :no-close-on-backdrop="true"
  >
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <b-card-body>
          <form autocomplete="off">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Nome do hotel *</label>
                  <input
                    id="name"
                    v-model="hotel.name"
                    name="name"
                    placeholder="Ex: Hotel Bela Vista"
                    type="text"
                    class="form-control"
                    :disabled="hotel.id && hotel.status !== 99"
                    :class="{
                      'is-invalid': submitted && $v.hotel.name.$error
                    }"
                  />
                  <div
                    v-if="submitted && !$v.hotel.name.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="address">Endereço *</label>
                  <input
                    id="address"
                    v-model="hotel.address"
                    name="address"
                    placeholder="Ex: Av. Paulista, 1000"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.hotel.address.$error
                    }"
                  />
                  <div
                    v-if="submitted && !$v.hotel.address.required"
                    class="invalid-feedback"
                  >
                    O campo email é obrigatório.
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="city">Cidade *</label>
                  <input
                    id="city"
                    v-model="hotel.city"
                    placeholder="Ex: São Paulo"
                    name="phone"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.hotel.city.$error
                    }"
                  />
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group">
                  <label for="state">UF *</label>
                  <select
                    class="form-control"
                    v-model="hotel.state"
                    :class="{ 'is-invalid': submitted && $v.hotel.state.$error }"
                  >
                    <option></option>
                    <option
                      v-for="(opt,idx) in states"
                      :key="idx"
                      :value="opt.value"
                    >
                      {{ opt.value || 'no label' }}
                    </option>
                  </select>
                  <div
                    v-if="submitted && !$v.hotel.state.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group">
                  <label for="zipcode">CEP</label>
                  <input
                    id="zipcode"
                    v-model="hotel.zipcode"
                    placeholder="Ex: 00000-000"
                    v-mask="'#####-###'"
                    name="phone"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>Datas de Check-in / Check-out *</label>
              <div class="row align-items-end mb-2" v-for="(range, idx) in hotel.dates" :key="idx">
                <div class="col-sm-5">
                  <label class="small text-muted mb-1">Check-in</label>
                  <date-picker
                    v-model="range.check_in"
                    :first-day-of-week="1"
                    lang="pt-br"
                    format="DD/MM/YYYY"
                    :class="{ 'is-invalid': submitted && !range.check_in }"
                  >
                  </date-picker>
                </div>
                <div class="col-sm-5">
                  <label class="small text-muted mb-1">Check-out</label>
                  <date-picker
                    v-model="range.check_out"
                    :first-day-of-week="1"
                    lang="pt-br"
                    format="DD/MM/YYYY"
                    :class="{ 'is-invalid': submitted && !range.check_out }"
                  >
                  </date-picker>
                </div>
                <div class="col-sm-2">
                  <button
                    type="button"
                    class="btn btn-outline-danger btn-sm"
                    v-if="hotel.dates && hotel.dates.length > 1"
                    @click="removeDateRange(idx)"
                    title="Remover período"
                  >
                    <i class="mdi mdi-trash-can-outline"></i>
                  </button>
                </div>
              </div>
              <div v-if="submitted && !datesValid" class="text-danger small mb-1">
                Preencha check-in e check-out de cada período.
              </div>
              <button type="button" class="btn btn-link p-0 mt-1" @click="addDateRange">
                <i class="mdi mdi-plus"></i> Adicionar datas
              </button>
            </div>
          </form>
        </b-card-body>
      </div>
    </div>
    <div class="row" v-if="hotel.id">
      <div class="col-lg-12">
        <b-card-body>
          <h5 class="font-size-14">Categorias e Acomodações</h5>
          <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted" lazy>
            <b-tab active>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-home"></i>
                </span>
                <span class="d-none d-sm-inline-block">Categorias</span>
              </template>
              <categories :idHotel=hotel.id></categories>
            </b-tab>
            <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="fas fa-cog"></i>
              </span>
              <span class="d-none d-sm-inline-block">Acomodação</span>
            </template>
            <accommodation :idHotel=hotel.id></accommodation>
          </b-tab>
          </b-tabs>
        </b-card-body>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button v-if="user.role === 'Admin' && hotel.id" variant="danger" @click="deletehotel(hotel)" class="float-left">Excluir Convidado</b-button>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" :disabled="hotel.id && hotel.status !== 99 && user.role !== 'Admin'" @click="savehotel()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Moment from 'moment'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import DatePicker from 'vue2-datepicker'
import { states } from '@/pages/participants/statesData'
import Categories from './categories/Categories'
import Accommodation from './accommodation/Accommodation'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { EventBus } from '@/eventBus'

export default {
  components: {
    Loading,
    DatePicker,
    Categories,
    Accommodation
  },
  data () {
    return {
      title: 'Adicionar Novo Hotel',
      listTags: [],
      loading: true,
      states: states,
      errorCPF: false,
      fullPage: true,
      submitted: false,
      hotel: { dates: [] },
      modal: false,
      modalForm: false
    }
  },
  validations: {
    hotel: {
      name: { required },
      address: { required },
      city: { required },
      state: { required }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('hotel', {
      getHotel: 'getHotel',
      postData: 'save',
      destroyhotel: 'deleteHotel'
    }),
    loadItem (id) {
      if (id) {
        this.title = 'Editar Hotel'
        this.getHotel(id).then((data) => {
          const ranges = (this.data.date_ranges && this.data.date_ranges.length)
            ? this.data.date_ranges.map(r => ({
              id: r.id,
              check_in: Moment(r.check_in, 'YYYY-MM-DD').toDate(),
              check_out: Moment(r.check_out, 'YYYY-MM-DD').toDate()
            }))
            : [{ check_in: null, check_out: null }]
          this.hotel = { ...this.data, dates: ranges }
        }).then(() => {
          this.loading = false
        })
      }
    },
    open (id = null) {
      this.modal = true
      this.loading = true
      if (id) {
        this.loadItem(id)
        return
      }
      this.hotel = { dates: [{ check_in: null, check_out: null }] }
      this.loading = false
    },
    addDateRange () {
      this.hotel.dates.push({ check_in: null, check_out: null })
    },
    removeDateRange (idx) {
      this.hotel.dates.splice(idx, 1)
    },
    async savehotel () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid || !this.datesValid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      const payload = { ...this.hotel }
      payload.date_ranges = (this.hotel.dates || []).map(r => ({
        id: r.id || null,
        check_in: Moment(r.check_in).format('YYYY-MM-DD'),
        check_out: Moment(r.check_out).format('YYYY-MM-DD')
      }))
      delete payload.dates
      await this.postData(payload).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('created')
        EventBus.$emit('hotelAdded', 1)
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.hotel = { dates: [] }
      this.$v.$reset()
      this.$emit('created')
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('event', ['setting']),
    ...mapState('hotel', { data: 'hotel' }),
    datesValid () {
      return this.hotel.dates &&
        this.hotel.dates.length > 0 &&
        this.hotel.dates.every(r => r.check_in && r.check_out)
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.modal-header {
  background: #000 !important;
  color: #fff;
}
.border-gray {
  border: 1px solid #e9e9e9;
}
</style>
